import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../Context/ConfigContext';
import Offers from './Offers';
import PopularProducts from './PopularProducts';
import Trending from './Trending';
import { Link } from 'react-router-dom';

const HeroSlider = () => {
    const { apiURL } = useContext(ConfigContext);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const GetSlider = async () => {
        try {
            const response = await axios.get(`${apiURL}Home/GetHomeSlider`);
            setData(response.data.data);
        } catch (err) {
            console.error("Error fetching slider data", err);
        }
    };

    useEffect(() => {
        GetSlider();
        document.title = 'StoneSkill';
    }, []);

    return (
        <>
            <main className='main'>
                <section className="home-slider position-relative mb-30">
                    <div className="container">
                        <div className="home-slide-cover mt-30">
                            <div className="hero-slider-1 style-4 dot-style-1 dot-style-1-position-1">
                                {/* {loading ? (
                                    // Show 2 shimmer slides
                                    Array.from({ length: 2 }).map((_, index) => (
                                        <div
                                            key={index}
                                            className="single-hero-slider single-animation-wrap shimmer-slide"
                                        >
                                            <div className="slider-content">
                                                <div className="shimmer shimmer-line mb-3" style={{ height: '40px', width: '60%' }}></div>
                                                <div className="shimmer shimmer-line mb-3" style={{ height: '16px', width: '40%' }}></div>
                                                <div className="shimmer shimmer-button" />
                                            </div>
                                        </div>
                                    ))
                                ) : ( */}
                                {data.map((item) => (
                                    <div
                                        key={item.slider_id}
                                        className="single-hero-slider single-animation-wrap"
                                        style={{ backgroundImage: `url(${item.slider_image_url})` }}
                                    >
                                        <div className="slider-content">
                                            <h1 className="display-2 mb-40 text-white">{item.slider_title}</h1>
                                            <p className="mb-65 text-white">{item.slider_description}</p>
                                            <Link to={`/AllProductsList/${item.category_title}=${item.category_id}`}>
                                                <button className='btn btn-danger'>
                                                    View More <i className='fa fa-arrow-right align-middle ms-1'></i>
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                                {/* )} */}
                            </div>
                            <div className="slider-arrow hero-slider-1-arrow" />
                        </div>
                    </div>
                </section>

                <Offers />
                <PopularProducts />
                <Trending />
            </main>
        </>
    );
};

export default HeroSlider;
